import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from 'projects/shared/src/lib/authentication/authentication.service';

const authStorageKey = 'efrmoirirjni';

function hasStoredSession() {
  try {
    return !!localStorage.getItem(authStorageKey);
  } catch {
    return false;
  }
}

const requireAuth = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (authService.isLoggedIn() || hasStoredSession()) {
    return true;
  }

  return router.createUrlTree(['/auth/login']);
};

export const mobileAuthGuard: CanActivateFn = requireAuth;
export const mobileAuthChildGuard: CanActivateChildFn = requireAuth;

export const mobileGuestGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    return router.createUrlTree(['/app/dashboard']);
  }

  return true;
};
